module.exports = __webpack_public_path__ + "img/step2.efb98205.png";